import React from "react";
import { Trans, useTranslation } from "react-i18next";
import tw, { css } from "twin.macro";

import Puzzle from "../../../static/icons/clock.svg";
import { BookMeeting } from "../../components/BookMeeting";
import { Container } from "../../components/Container";

const cards = css`
  ${tw`flex flex-col py-8 max-w-3xl mx-auto flex flex-wrap items-center text-center pt-20`}
  h2 {
    ${tw`mx-auto`}
  }
    p {
    ${tw`text-xl`}
  }
    .svg-text {
    ${tw`text-3xl sm:text-5xl mx-auto`}
  }
    #discoverSolutions {
    ${tw`text-xl sm:text-4xl font-black text-center mt-10`}
  }
  .clock {
    ${tw`flex items-center gap-4 text-turquoise`}
    svg {
      ${tw` w-[150px] h-[150px] sm:max-w-[200px] sm:max-h-[200px] mx-auto fill-current mx-auto`}
      > g {
        ${tw`fill-current`}
      }
    }
  }
}
#agency-stage-1 {
  ${tw`pt-[5rem]`}
}
`;

const AgencyStage1: React.FC = ({ ...rest }) => {
  const { t } = useTranslation();
  return (
    <Container {...rest}>
      <section css={cards} id="agency-stage-1">
        <h2>
          <Trans i18nKey={t("AgencyServices.stage1.header")} components={{ br: <br /> }} />
        </h2>
        <span tw="bg-turquoise text-white border-solid border-black border text-2xl font-bold px-5 py-2 sm:text-3xl">
          {t("AgencyServices.stage1.step")}
        </span>
        <p tw="my-10 font-bold">{t("AgencyServices.stage1.question")}</p>
        <p tw="mb-10">{t("AgencyServices.stage1.answer")}</p>
        <div className="clock">
          <Puzzle />
          <p className="svg-text">
            <Trans i18nKey={t("AgencyServices.stage1.timeFrame")} components={{ br: <br /> }} />
          </p>
        </div>
        <p tw="mt-10">{t("AgencyServices.stage1.whyUs")}</p>
        <p id="discoverSolutions">{t("AgencyServices.stage1.outro")}</p>
        <BookMeeting commentFirst={true} />
      </section>
    </Container>
  );
};

export default AgencyStage1;
